<template>
  <tr>
    <td class="v-align-middle col-md-2">
      <ul>
        <li>Roger Rabbit</li>
        <li>roger.rabbit@test.com</li>
        <li>0678903423</li>
      </ul>
    </td>
    <td class="v-align-middle col-md-1"> {{sent_datetime | moment-fulldatetime}}</td>
    <td class="v-align-middle col-md-2"> Bugs Bunny</td>
    <td class="v-align-middle col-md-1">{{ received_datetime | moment-fulldatetime }}</td>
    <td class="v-align-middle"> Demande d'informations </td>
    <td class="v-align-middle"> Bonjour, je suis à la recherche d'un local commercial pour vendre mes carottes. Pourriez vous me recontacter dans le but de faire un partenariat dans la vente de ces delicieuses racines. </td>
  </tr>
</template>

<script>
export default {
  name:"Item",
  props:["customer", "message"],

  data () {
    return {
      received_datetime:moment(),
      sent_datetime:moment(),
    }
  },
  
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/Customer/HotlineContent/Item.vue